import {Component, Input} from '@angular/core';
import {BaseResultComponent} from '../base-result/base-result.component';
import {FamilyIncomeResult} from '../../../class/result/family-income-result';
import {Desktop} from '../../../class/desktop';
import {PersonKind} from '../../../class/person-kind.enum';
import {Person} from '../../../class/person';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-income-result',
  templateUrl: './income-result.component.html',
  styleUrls: ['./income-result.component.css']
})
export class IncomeResultComponent extends BaseResultComponent {

  @Input()
  familyIncomeResult: FamilyIncomeResult;

  @Input()
  desktop: Desktop;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  ngOnInitImpl(): void {
  }

  isChild(person: Person): boolean {
    return person.kind === PersonKind.CHILD;
  }

  private getDescriptionByKind(personKind: PersonKind) {
    switch (personKind) {
      case PersonKind.HUSBAND: {
        return 'Marito';
      }
      case PersonKind.WIFE: {
        return 'Moglie';
      }
      case PersonKind.CHILD: {
        return 'Figlio';
      }
      case PersonKind.OTHER: {
        return 'Altro';
      }
      case PersonKind.SINGLE: {
        return 'Capo Famiglia';
      }
    }
  }
}
